import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('../../shared/sov-shared.i18n.json'));

const SHARED_MSG_KEY = 'sov_shared';

export const buildDateString = (
  msgKey: 'created' | 'updated',
  date?: string | null,
  addTimestamp?: boolean
): string | undefined | null => {
  const format = addTimestamp ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY';

  return date && `${__t(`${SHARED_MSG_KEY}.labels.${msgKey}`)}: ${moment(date).format(format)}`;
};

export const getReportModifiedDate = (
  createdAt?: string | null,
  updatedAt?: string | null,
  addTimestamp?: boolean
): string | undefined | null => {
  const created = !isNil(createdAt) ? moment(createdAt).utc().format('YYYY-MM-DD HH:mm') : '';
  const updated = !isNil(updatedAt) ? moment(updatedAt).utc().format('YYYY-MM-DD HH:mm') : '';

  if (isEmpty(created) && isEmpty(updated)) {
    return '';
  }

  const areDatesEqual = moment(created).isSame(updated);

  if (areDatesEqual || isEmpty(updated)) {
    return buildDateString('created', created, addTimestamp);
  }

  return buildDateString('updated', updated, addTimestamp);
};
